import * as React from 'react';
import RouteIfRights from 'pages/router/RouteIfRights';

import LightspeedCapitalIframe from './index';

type Paths = {
  lightspeedCapital: string;
};

interface RequiredModule {
  modules?: ModuleName | ModuleName[];
}

const requiredModule: RequiredModule = {};

export const paths: Paths = {
  lightspeedCapital: '/payments/lightspeed-capital',
};

export default [
  <RouteIfRights
    path={paths.lightspeedCapital}
    component={LightspeedCapitalIframe}
    key={paths.lightspeedCapital}
    {...requiredModule}
  />,
];
